<template>
  <md-card style="z-index: 0">
    <md-card-content class="body-card-actions">
      <h3>Actions</h3>
      <md-button
        class="md-primary add-action"
        @click.native="addAction"
      >
        Add Action
      </md-button>

      <md-progress-bar
        v-if="loading"
        md-mode="indeterminate"
      />

      <md-card
        v-for="(a, index) in actions"
        v-else
        :key="a.uiId"
        class="action-card"
      >
        <md-card-content>
          <div class="actions-top-line">
            <div class="title-wrapper">
              <language-key-form
                title="title"
                :values="a.title"
                @update="(v) => onTitleChange(index, v)"
              />
            </div>
            <div class="buttons-wrapper">
              <md-button
                class="md-icon-button"
                style="padding: 5px 0 5px 0; background-color: #ff1745 !important; margin-top: 0 !important;"
                @click.native="showDeleteDialog(index)"
              >
                <md-icon>delete</md-icon>
              </md-button>

              <md-button
                class="md-icon-button"
                style="padding: 5px 0 5px 0;"
                @click.native="copyAction(index)"
              >
                <md-icon>content_copy</md-icon>
              </md-button>
            </div>
          </div>

          <div class="actions-top-line">
            <div class="title-wrapper">
              <language-key-form
                title="subtitle"
                :values="a.subtitle"
                @update="(v) => onSubtitleChange(index, v)"
              />
            </div>
          </div>

          <div class="actions-bottom-line">
            <div class="image-field">
              <img :src="a.imageUrl">
              <md-field md-inline>
                <label>Image URL</label>
                <md-input v-model="a.imageUrl" />
              </md-field>
            </div>

            <md-field
              style="width: 82px"
              md-inline
            >
              <label>Platform</label>
              <md-select v-model="a.platform">
                <md-option value="all">
                  All
                </md-option>
                <md-option value="iOS">
                  iOS
                </md-option>
                <md-option value="macos">
                  macOS
                </md-option>
                <md-option value="android">
                  Android
                </md-option>
                <md-option value="windows">
                  Windows
                </md-option>
                <md-option value="web">
                  Web
                </md-option>
              </md-select>
            </md-field>

            <md-field md-inline>
              <label>App URL</label>
              <md-input v-model="a.url.app" />
            </md-field>

            <md-field md-inline>
              <label>Website URL</label>
              <md-input v-model="a.url.website" />
            </md-field>

            <md-field md-inline>
              <label>Store URL</label>
              <md-input v-model="a.url.store" />
            </md-field>
          </div>
        </md-card-content>
      </md-card>
    </md-card-content>

    <md-dialog-confirm
      :md-active.sync="isDeleteDialogActive"
      md-title="Delete this action?"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-cancel="isDeleteDialogActive = false"
      @md-confirm="deleteAction"
    />
  </md-card>
</template>
<script>
    import LanguageKeyForm from "@/components/Forms/LanguageKeyForm";
    import { uiId } from "@/utils/uiId";

    export default {
        components: { LanguageKeyForm },
        props: {
          actions: { type: Array, default() { return []; } },
          loading: Boolean
        },
        data() {
            return {
                isDeleteDialogActive: false,
                actionToDelete: ""
            };
        },
        methods: {
            onTitleChange(index, newValue) {
                this.actions[index].title = newValue;
            },
            onSubtitleChange(index, newValue) {
                this.actions[index].subtitle = newValue;
            },
            addAction() {
                this.actions.push({
                    id: "",
                    title: { "en": "" },
                    subtitle: { "en": "" },
                    imageUrl: "",
                    url: {
                        app: "",
                        website: "",
                        store: ""
                    },
                    platform: "all",
                    uiId: uiId()
                });
            },
            copyAction(index) {
                // deep copy
                const newAction = JSON.parse(JSON.stringify(this.actions[index]));
                newAction.uiId = uiId();
                this.actions.splice(index, 0, newAction);
            },
            showDeleteDialog(index) {
                this.isDeleteDialogActive = true;
                this.actionToDelete = index;
            },
            deleteAction() {
                this.actions.splice(this.actionToDelete, 1);
                this.isDeleteDialogActive = false;
            }
        }
    };
</script>
<style lang="scss">
    .action-card {
        margin: 10px 0 !important;

        .md-card-content {
            padding: 8px 20px 8px 20px !important;
        }
    }

    .body-card-actions {
        h3 {
            position: absolute;
            margin: 0;
        }

        button.add-action {
            position: sticky;
            top: 5px;
            left: 95%;
            margin: 0;
            z-index: 100;
        }
    }

    .image-field {
        width: auto;
        min-width: 140px;
        display: flex;

        img {
            margin: 25px 5px 0 0 !important;
            width: 25px !important;
            height: 25px !important;
        }
        .md-field {
            margin: 0 10px 0 0;
        }
    }

    .actions-top-line {
        display: flex;
        justify-content: space-between;
        flex-direction: row;

        .title-wrapper {
            width: calc(100% - 50px);
        }
        .buttons-wrapper {
            min-width: 40px;
            width: 40px;
            margin-left: 10px;
        }
    }

    .actions-bottom-line {
        display: flex;
        justify-content: space-between;
        margin-top: -20px;
        overflow-x: auto;

        .md-field {
            margin: 0 10px 0 0;
            min-width: 80px;
            width: auto;
            overflow-x: hidden;
        }
    }

    @media only screen and (max-width: 850px) {
        .actions-top-line {
            display: flex;
            justify-content: space-between;
            flex-direction: column-reverse;

            .buttons-wrapper {
                width: 100%;
                margin: 0 0 5px 0;
                button {
                    margin: 0;
                }
                button ~ button {
                    float: right;
                }
            }
            .title-wrapper {
                width: 100%;
            }
        }

        .actions-bottom-line {
            flex-direction: column;
            margin-top: 0;

            div {
                width: 100% !important;
            }
        }
    }
    @-webkit-media only screen and (max-width: 850px) {
        .actions-top-line {
            display: flex;
            justify-content: space-between;
            flex-direction: column-reverse;

            .buttons-wrapper {
                width: 100%;
                margin: 0 0 5px 0;
                button {
                    margin: 0;
                }
                button ~ button {
                    float: right;
                }
            }
            .title-wrapper {
                width: 100%;
            }
        }

        .actions-bottom-line {
            flex-direction: column;
            margin-top: 0;

            div {
                width: 100% !important;
            }
        }
    }
</style>
